export default __webpack_public_path__ + "static/media/113t.a16a4f4b.jpg";